// Snackbar notification utility

export function showSnackbar(message, type = 'info', iconName = null, durationMs = 5000) {
    let snackbar = document.getElementById('bmsSnackbar');
    if (!snackbar) {
        snackbar = document.createElement('div');
        snackbar.id = 'bmsSnackbar';
        snackbar.className = 'bms-snackbar';
        const iconSpan = document.createElement('span');
        iconSpan.className = 'material-symbols-rounded notranslate snackbar-icon';
        snackbar.appendChild(iconSpan);
        const textSpan = document.createElement('span');
        textSpan.className = 'snackbar-text';
        snackbar.appendChild(textSpan);
        document.body.appendChild(snackbar);
    }
    const iconSpan = snackbar.querySelector('.snackbar-icon');
    const textSpan = snackbar.querySelector('.snackbar-text');
    if (iconName) {
        iconSpan.textContent = iconName;
        iconSpan.style.display = 'inline-flex';
    } else {
        iconSpan.style.display = 'none';
    }
    textSpan.textContent = message;
    snackbar.setAttribute('data-type', type);
    snackbar.classList.add('show');
    setTimeout(() => {
        snackbar.classList.remove('show');
    }, durationMs);
}
